import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";

export const LIVESTREAM_MAX_DURATION_CLAIM = "livestream:maxduration";

export interface LivestreamMinutes {
    hasLimit: boolean;
    usedSeconds: number;
    maxSeconds: number;
    usedRatio: number;
    remainingSeconds: number;
    periodEnd?: string;
    isOutOfMinutes: boolean;
}

export const useLivestreamMinutes = (): LivestreamMinutes => {
    const userInfo = useSelector((s: RootState) => s.user.userInfo);
    const limitClaim =
        userInfo?.Claims?.Details?.FeatureLimitClaims?.[
            LIVESTREAM_MAX_DURATION_CLAIM
        ];
    const usedClaim = userInfo?.MetaData?.Details?.StreamingDurationSeconds;
    const periodEnd = userInfo?.MetaData?.Details?.StreamingDurationPeriodEnd;

    return useMemo(() => {
        const maxSeconds = limitClaim ?? 0;
        const hasLimit = maxSeconds > 0;
        const usedSeconds = usedClaim ?? 0;
        const usedRatio = hasLimit ? usedSeconds / maxSeconds : 0;

        return {
            hasLimit,
            usedSeconds,
            maxSeconds,
            usedRatio,
            remainingSeconds: Math.max(maxSeconds - usedSeconds, 0),
            periodEnd,
            isOutOfMinutes: hasLimit && usedSeconds >= maxSeconds
        };
    }, [limitClaim, usedClaim, periodEnd]);
};
